type BackMobileVariant = "chevron" | "close";

interface BackProps {
  onBack: () => void;
  label: string;
  /** RN-webview surfaces show a close icon instead of a chevron on mobile. */
  mobileVariant?: BackMobileVariant;
}

/**
 * Slot marker for CheckoutProgressHeader — renders nothing itself; the root
 * reads its props and renders the back control inside the shared frame.
 */
const Back = (_unusedProps: BackProps) => null;

export { Back };
export type { BackMobileVariant, BackProps };
